export const Executives = [
  {
    title: "Avni Kapoor",
    img: "Avni.webp",
    linkedin: "https://www.linkedin.com/in/avni-kapoor/",
    position: "Co-president",
    lastPosition: "",
  },
  {
    title: "Hinako Kamiya",
    img: "Hinako.webp",
    linkedin: "https://www.linkedin.com/in/hinako-kamiya/",
    position: "Co-president",
    lastPosition: "",
  },
  {
    title: "Ronney Lok",
    img: "Ronney.webp",
    linkedin: "https://www.linkedin.com/in/ronneylok/",
    position: "VP Engineering",
    lastPosition: "",
  },
  {
    title: "Praevalli Rajah",
    img: "praevalli.webp",
    linkedin: "https://www.linkedin.com/in/praevalli-rajah/",
    position: "VP External",
    lastPosition: "",
  },
  {
    title: "Melvika Faustine",
    img: "melvika.webp",
    linkedin: "https://www.linkedin.com/in/melvika/",
    position: "VP Internal",
    lastPosition: "",
  },
  {
    title: "Terry Kwok",
    img: "Terry.webp",
    linkedin: "https://www.linkedin.com/in/lai-chit-kwok-6074472b5/",
    position: "VP Internal",
    lastPosition: "",
  },
  {
    title: "Ananya Singh",
    img: "ananya.webp",
    linkedin: "https://www.linkedin.com/in/ananyaxsingh/",
    position: "VP Product",
    lastPosition: "",
  },
  {
    title: "Nicolas Ramirez",
    img: "nicolas.webp",
    linkedin: "https://www.linkedin.com/in/nicolas-ramirez-pm/",
    position: "VP Product",
    lastPosition: "",
  },
  {
    title: "Caron McPherson",
    img: "caron.webp",
    linkedin: "https://www.linkedin.com/in/caron-isaiah-mcpherson-71b562278/",
    position: "VP Marketing",
    lastPosition: "",
  },
  {
    title: "Kate Simone",
    img: "Kate.webp",
    linkedin: "https://www.linkedin.com/in/kate-simone-866335284/",
    position: "VP Design",
    lastPosition: "",
  },
  {
    title: "Sylvia Zhang",
    img: "Sylvia.webp",
    linkedin: "https://www.linkedin.com/in/sylvia-zhang-siqi/",
    position: "VP Scoping",
    lastPosition: "",
  },
  {
    title: "Irvin Cardoza",
    img: "irvin.webp",
    linkedin: "https://www.linkedin.com/in/irvincardoza/",
    position: "VP Scoping",
    lastPosition: "",
  },
  {
    title: "Fatma Omer ",
    img: "Fatma.webp",
    linkedin: "https://www.linkedin.com/in/fatmabinteomer/",
    position: "VP Talent",
    lastPosition: "",
  },
];
